/*
Coloca cuatro rectangulos en una fila.
Autor: Benjamín León
Fecha: 2024-10-13

*/
import React from 'react'

const RectangleRow: React.FC = () => {
  return (
    <>
      <div className="mt-4 text-2xl">Combustible</div>
      <div className="flex w-full  space-x-2">
        <div className="flex-grow h-10 border border-gray-500 rounded-l-lg"></div>
        <div className="flex-grow h-10 border border-gray-500"></div>
        <div className="flex-grow h-10 border border-gray-500"></div>
        <div className="flex-grow h-10 border border-gray-500 rounded-r-lg"></div>
      </div>
    </>
  )
}

export default RectangleRow
